import { ChangeEvent, useCallback, useContext, useEffect, useState } from 'react';
import { GetUserInfo } from 'components/util/Helpers/Auth';
import { AuthContext } from 'contexts/AuthContext';

export interface ISupplier {
  id: string;
  name: string;
}

export const useSuppliers = () => {
  const {
    user: { isVisaoTok }
  } = useContext(AuthContext);

  const handleChangeSupplier = (_: ChangeEvent<{}>, supplier: ISupplier | null) => {
    const supplierId = supplier ? parseInt(supplier.id) : 0;
    setCurrentSupplierId(supplierId);
  };

  const [currentSupplierId, setCurrentSupplierId] = useState(0);
  const [supplierLoading, setSupplierLoading] = useState(false);
  const getUserInfo = useCallback(async () => {
    setSupplierLoading(true);
    GetUserInfo()
      .then(({ id }) => {
        setCurrentSupplierId(id);
      })
      .finally(() => {
        setSupplierLoading(false);
      });
  }, []);

  useEffect(() => {
    const setSupplier = async () => {
      if (!isVisaoTok) {
        await getUserInfo();
      }
    };

    setSupplier();
  }, []);

  return { currentSupplierId, handleChangeSupplier, supplierLoading };
};
